import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { BASEAPIURL, token } from "../env";

// Configure PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function JaiclubLive() {
  const [newsletters, setNewsletters] = useState([]);
  const [pdfThumbnails, setPdfThumbnails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNewsletters = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${BASEAPIURL}/GetNewsLetter`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ tokenData: token }),
        });

        const result = await response.json();

        if (result.status === true && Array.isArray(result.data)) {
          setNewsletters(result.data);

          // Generate thumbnails
          result.data.forEach(async (item) => {
            const canvas = document.createElement("canvas");
            const thumbnailUrl = await getPDFThumbnail(item.Document, canvas);
            setPdfThumbnails((prev) => ({
              ...prev,
              [item.Document]: thumbnailUrl,
            }));
          });
        } else {
          console.error("Invalid response:", result);
        }
      } catch (error) {
        console.error("Error fetching newsletters:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsletters();
  }, []);

  const getPDFThumbnail = async (url, canvas) => {
    try {
      const isBase64 = url.startsWith("data:");
      const loadingTask = isBase64
        ? pdfjsLib.getDocument({ data: Uint8Array.from(atob(url.split(",")[1]), c => c.charCodeAt(0)) })
        : pdfjsLib.getDocument(url);

      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1.5 });
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport }).promise;

      return canvas.toDataURL();
    } catch (error) {
      console.error("Error generating thumbnail:", error);
      return null;
    }
  };

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const openPDFInPrintView = (item) => {
    if (!item?.Document) return;
  
    const isBase64 = item.Document.startsWith("data:");
    let pdfUrl;
  
    if (isBase64) {
      try {
        const byteCharacters = atob(item.Document.split(",")[1]);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        pdfUrl = URL.createObjectURL(blob);
      } catch (error) {
        console.error("Error processing Base64 PDF:", error);
        alert("Unable to open PDF. Please try again.");
        return;
      }
    } else {
      pdfUrl = item.Document;
    }
  
    if (isMobile) {
      // For mobile, redirect to the PDF or prompt download
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `newsletter-${item.Heading}.pdf`; // Suggest download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Desktop: try to open and print
      const win = window.open(pdfUrl, "_blank");
      if (win) {
        win.focus();
        try {
          win.onload = () => {
            win.print();
          };
        } catch (error) {
          console.warn("Print not supported:", error);
        }
      } else {
        alert("Popups may be blocked. Please open the PDF manually.");
        window.location.href = pdfUrl;
      }
    }
  
    if (isBase64) {
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
    }
  };

  return (
    <div className="container py-5">
      <h2 className="text-center text-dark mb-5">Jai Club Live</h2>

      <div className="row justify-content-center">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading newsletters...</span>
            </div>
          </div>
        ) : newsletters.length === 0 ? (
          <p className="text-center text-muted">No newsletters found.</p>
        ) : (
          newsletters.map((item, index) => (
            <div
              key={index}
              className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
              style={{ cursor: "pointer" }}
              onClick={() => openPDFInPrintView(item)}
            >
              <div className="card h-100 shadow-lg border-0 rounded-3 overflow-hidden card-hover">
                <div className="card-img-top" style={{ height: "200px", overflow: "hidden" }}>
                  {pdfThumbnails[item.Document] ? (
                    <img
                      src={pdfThumbnails[item.Document]}
                      alt="PDF Preview"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <div className="d-flex justify-content-center align-items-center h-100 bg-light">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading preview...</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="card-body text-center">
                  <h5 className="card-title fs-5">{item.Heading}</h5>
                  <span className="card-text">{item.Description}</span>
                  <p className="card-text text-muted">{item.DateRange}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

    </div>

    
  );
}
